(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('property-detail', {
                url: "/:langcode/properties/:id/:name?item?rent",
                templateUrl: '/app/endeks/houses-detail.html',
                controller: 'PropertyDetailController',
                controllerAs: "vm",
                metaTags: {
                    robots: 'noindex, nofollow'
                },
                params: {

                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    },
                    id: { type: 'any', raw: true },
                    name: { type: 'any', raw: true },
                    item: { type: 'any', raw: true }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        // Load propertyDetail bundle + maps bundle for Google Maps API
                        var bundles = ['propertyDetail', 'maps'];
                        return lazyLoadSvc.load($transition$, bundles);
                    }],
                    HasPackage: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage();
                    }],
                    HasPro: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "eco-package",
                            "premium-package",
                            "premiumplus-package",
                            "pro-ee-package",
                            "flex-package",
                            "gold-package",
                            "terminal-flex-package",
                            "terminal-pro-package",
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package",
                            "real-estate-package",
                            "location-package",
                        ]);
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart("valuation_house_details");
                        $translatePartialLoader.addPart("analysis_value");
                        $translatePartialLoader.addPart("endeks_modal");
                        $translatePartialLoader.addPart("property_details");
                        $translatePartialLoader.addPart("properties"); // Investment analysis translations
                        $translatePartialLoader.addPart("valuation_step1");
                        $translatePartialLoader.addPart("valuation_step2");
                        $translatePartialLoader.addPart("valuation_step3");
                        $translatePartialLoader.addPart("valuation_step4");
                        $translatePartialLoader.addPart("product_report");
                        $translatePartialLoader.addPart("payment");
                        return $translate.refresh();
                    }]
                }

            });
    }]);


})();
